//import Libraries
import React, { Component } from 'react'
import { connect } from 'react-redux';
import {Button} from 'reactstrap';

//import Components
import {Modal} from 'reactstrap';
import SignUpTextField from './Elements/SignUpTextField';
import Icons from '../../assets/icons/icons';

import Language from '../../language/language.json'

import * as signupActions from './actions/signUpActions';
import * as validations from '../../utils/validations'

//import Style classes
import './SignUp.css';

class SignUp extends Component {
    constructor(props){
        super(props);
        this.state = {
            nestedModal : '',
            closeAll : false,

            email: '',
            emailError : '',
            password: '',
            passwordError : '',
            fullName : '',
            fullNameError : '',
            company : '',
            companyError : '',
            address : '',
            addressError : '',
            phone : '',
            phoneError : '',

            greenhouseType : '',
            greenhouseTypeError : '',

            plantType : '',
            platTypeError : '',

            areaSize : '',
            areaSizeError : ''
        }
    }

    toggleNested = () =>  {
        this.props.onResetAuth();
        this.setState(prevState => ({
            nestedModal : !prevState.nestedModal,
            closeAll : false
        }))
    }
    
    toggleAll = () =>  {
        this.setState(prevState => ({
            nestedModal : !prevState.nestedModal,
            closeAll : true
        }))
    }

    handleEmailChange = (e) => {
        let emailError = '';
        if(!validations.validateEmail(e.target.value)){
            emailError= Language.signUp.validation.email[this.props.universal.language]
        }
        this.setState({
            [e.target.name] : e.target.value,
            emailError
        })
    }
    handlePasswordChange = (e) => {
        let passwordError = '';
        if(!validations.validatePasswordSpecialCharacters(e.target.value)) {
            passwordError = Language.signUp.validation.password.specialCharacters[this.props.universal.language];
        }
        if(!validations.validatePasswordNumber(e.target.value)) {
            passwordError = Language.signUp.validation.password.hasNumber[this.props.universal.language];
        }
        if(!validations.validatePasswordAlphabet(e.target.value)) {
            passwordError = Language.signUp.validation.password.hasAlphabet[this.props.universal.language];
        }
        if(!validations.validatePasswordLength(e.target.value)) {
            passwordError = Language.signUp.validation.password.short[this.props.universal.language];
        }
        this.setState({
            [e.target.name] : e.target.value,
            passwordError
        })
    }
    handlePhoneChange = (e) => {
        let phoneError = '';
        if(!validations.validatePhone(e.target.value)) {
            phoneError =  Language.signUp.validation.phone[this.props.universal.language];
        }
        this.setState({
            [e.target.name] : e.target.value,
            phoneError
        })
    }

    handleRequiredChange = (e) => {
        let error = '';
        if (!validations.validateRequired(e.target.value)) {
            error = Language.signUp.validation.required[this.props.universal.language];
        }
        this.setState({
            [e.target.name] : e.target.value,
            [`${e.target.name}Error`] : error
        })
    }

    canSignUp = () => {
        return (this.state.emailError === '' && this.state.email !== '' &&
                this.state.passwordError === '' && this.state.password !== '' &&
                this.state.fullNameError === '' && this.state.fullName !== '' &&
                this.state.companyError === '' &&
                this.state.addressError === '' && this.state.address !== '' && 
                this.state.phoneError === '' && this.state.phone !== '' &&
                this.state.greenhouseTypeError === '' && this.state.greenhouseType !== '' &&
                this.state.plantTypeError === '' && this.state.plantType !== '' &&
                this.state.areaSizeError === '' && this.state.areaSize !== '');
        }

    handleOnChange = (e) => {
        this.setState({
            [e.target.name] : e.target.value
        })
    }

    handleOnSignUp = () => {
        const {email, password, fullName, company, address, phone, greenhouseType, plantType, areaSize} = this.state;
        this.props.onSignUp({ email, password, fullName, company, address, phone, greenhouseType, plantType, areaSize})
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.signUp) {
            if(!prevProps.signUp.success && this.props.signUp.success) {
                this.toggleNested();
            }
        }
    }

    render() {
        const {language} = this.props.universal

        return (
            <div>
                <Modal 
                    isOpen={this.props.modal} 
                    toggle={this.props.toggle}
                >   
                    <div className="signup-container">
                    <div className="Logo">{Icons.logo}</div>
                        <div className="title">
                            {Language.signUp.title[language]}
                        </div>
                        <div className="content">
                            <SignUpTextField
                                type="email"
                                placeholder={Language.signUp.email[language]}
                                onChange={this.handleEmailChange}
                                value={this.state.email}
                                name="email"
                                autoComplete="off"
                                required={true}
                                errorMessage={this.state.emailError}
                            />
                            <SignUpTextField
                                type="password"
                                placeholder={Language.signUp.password[language]}
                                onChange={this.handlePasswordChange}
                                value={this.state.password}
                                name="password"
                                autoComplete="off"
                                required={true}
                                errorMessage={this.state.passwordError}
                            />
                            <SignUpTextField
                                type="text"
                                placeholder={Language.signUp.firstName[language]}
                                onChange={this.handleRequiredChange}
                                value={this.state.fullName}
                                name="fullName"
                                autoComplete="off"
                                required={true}
                                errorMessage={this.state.firstNameError}
                            />
                            <SignUpTextField
                                type="text"
                                placeholder={Language.signUp.company[language]}
                                onChange={this.handleRequiredChange}
                                value={this.state.company}
                                name="company"
                                autoComplete="off"
                                required={true}
                                errorMessage={this.state.companyError}
                            />
                            <SignUpTextField
                                type="text"
                                placeholder={Language.signUp.phone[language]}
                                onChange={this.handlePhoneChange}
                                value={this.state.phone}
                                name="phone"
                                autoComplete="off"
                                required={true}
                                errorMessage={this.state.phoneError}
                            />
                            <SignUpTextField
                                type="text"
                                placeholder={Language.signUp.address[language]}
                                onChange={this.handleRequiredChange}
                                value={this.state.address}
                                name="address"
                                autoComplete="off"
                                required={true}
                                errorMessage={this.state.addressError}
                            />

                            <SignUpTextField
                                type="text"
                                placeholder={Language.signUp.greenhouseType[language]}
                                onChange={this.handleRequiredChange}
                                value={this.state.greenhouseType}
                                name="greenhouseType"
                                autoComplete="off"
                                required={true}
                                errorMessage={this.state.greenhouseTypeError}
                            />
                            <SignUpTextField
                                type="text"
                                placeholder={Language.signUp.plantType[language]}
                                onChange={this.handleRequiredChange}
                                value={this.state.plantType}
                                name="plantType"
                                autoComplete="off"
                                required={true}
                                errorMessage={this.state.plantTypeError}
                            />
                            <SignUpTextField
                                type="text"
                                placeholder={Language.signUp.areaSize[language]}
                                onChange={this.handleRequiredChange}
                                value={this.state.areaSize}
                                name="areaSize"
                                autoComplete="off"
                                required={true}
                                errorMessage={this.state.areaSizeError}
                            />
                            <div className="element">
                            {
                                this.props.signUp && this.props.signUp.message && 
                                (
                                    <div>
                                        {this.props.signUp.message}
                                    </div>
                                )
                            }
                            </div>
                            <div className="element">
                                <Button 
                                    size="lg"
                                    color="info"
                                    className="btn"
                                    onClick={this.handleOnSignUp}
                                    disabled={this.canSignUp() ? false : true}
                                >
                                    {Language.signUp.up[language]}
                                </Button>
                            </div>
                        </div>
                        <div className="footer">
                        </div>
                    </div>
                    <Modal 
                        isOpen={this.state.nestedModal} 
                        toggle={this.toggleNested}
                        onClosed={this.state.closeAll ? this.props.toggle : undefined}
                    >
                        <div className="signup-container">
                            <div className="title">
                                {Language.signUp.success.title[language]}
                            </div>
                            <div className="content">
                                <div className="element">
                                    {Language.signUp.success.content[language]}
                                </div>
                                <div className="element">
                                    <Button 
                                        className="btn"
                                        onClick={this.toggleAll}
                                    >
                                        {Language.signUp.success.confirm[language]}
                                    </Button>
                                </div>
                            </div>
                            <div className="footer">
                            </div>
                        </div>
                    </Modal>
            </Modal>
           </div>
        );
    }
}

const mapStateToProps = (state)=>{
    return {
        universal : state.universal,
        signUp : state.sign.signUp
    }
}

const mapDispatchToProps = (dispatch, ownProps)=>{
    return {
        onResetAuth : () => {
            dispatch({ type: 'RESET_AUTH' })
        },
        onSignUp : (signUpData)=> {
            dispatch(signupActions.signUp(signUpData));
        }
    }

}

export default connect(mapStateToProps, mapDispatchToProps)(SignUp);



// WEBPACK FOOTER //
// ./src/components/SignUp/SignUp.js